module.exports = __webpack_public_path__ + "static/media/credem.9b4e5d9b.png";